export const resolvePlTotal = ({
  backendTotal,
  localTotal,
  hasBrokerFilter,
}) => {
  const numericBackend = toFiniteNumber(backendTotal)
  const numericLocal = toFiniteNumber(localTotal)
  if (!hasBrokerFilter && numericBackend !== null) {
    return numericBackend
  }
  return numericLocal === null ? 0 : numericLocal
}

const toFiniteNumber = (raw) => {
  if (raw === null || raw === undefined) return null
  const n = Number(raw)
  return Number.isFinite(n) ? n : null
}
